// extracted by mini-css-extract-plugin
export var active = "_9y-7";
export var blink = "_9y-8";
export var dropDownSelector = "_9y-4";
export var dropDownWrapper = "_9y-3";
export var fakeCursor = "_9y-6";
export var formQuillEditor = "_9y-0";
export var qlBlank = "_9y-1";
export var textFormattingToolbar = "_9y-2";
export var textToolbarOption = "_9y-5";